<div class="bt-container" [class.disabled]="loading">
  <button class="c-btn" (click)="nextStepAction()">
    <span *ngIf="loading" class="loading">
      <img src="./assets/images/button-loading.gif" />
    </span>
    <p>{{ buttonTitle | translate }}</p>
    <i class="u-icon ion-ios-arrow-forward"></i>
  </button>
</div>